import { GetRowIdParams } from 'ag-grid-enterprise'
import { Trash2 } from 'lucide-react'
import { renderToString } from 'react-dom/server'

import { CustomAgGrid, createContextMenu, getBasicColDefsFromData } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { MarketSummary } from '@fortem-monorepo/web-sdk'

import { useMarketSummaryActions } from '@/pages/instruments/market-summary/market-summary-actions'
import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

export interface MarketSummaryEventsTabProps {}

export const MarketSummaryEventsTab: React.FC<MarketSummaryEventsTabProps> = () => {
  const { eventsQuery, hasWriteAccess } = useMarketSummaryContext()

  const { removeEvent, actionState } = useMarketSummaryActions()

  const contextMenu = createContextMenu<MarketSummary.Event>((params) => {
    const row = params.node?.data
    const defaults = params.defaultItems ?? []
    if (!row || params.node?.group) return defaults

    return [
      ...(hasWriteAccess
        ? [
            {
              name: 'Delete Event',
              icon: renderToString(<Trash2 size={16} />),
              cssClasses: ['text-red-600!'],
              disabled: actionState !== null,
              action: () => removeEvent({ event_id: row.event_id }),
            },
            'separator',
          ]
        : ([] as any)),
      ...defaults,
    ]
  })

  return (
    <div className={'flex-1 h-full'}>
      <Widget exposed className={'h-full'}>
        <WidgetHeaderWithQuery query={eventsQuery} title="Events" />
        <WidgetContent loading={eventsQuery.isLoading}>
          <CustomAgGrid
            getContextMenuItems={contextMenu}
            rowData={eventsQuery.data}
            query={eventsQuery}
            getRowId={(row: GetRowIdParams<MarketSummary.Event>) => row.data.event_id.toString()}
            columnDefs={getBasicColDefsFromData(eventsQuery.data ?? [])}
            domLayout={'normal'}
          />
        </WidgetContent>
      </Widget>
    </div>
  )
}
